import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled, { css } from "styled-components";
import { colors, fontSize, margins, position, verticalAlign } from "../../core/enhancers";

var iconAsButtonStyles = function iconAsButtonStyles(_ref) {
  var theme = _ref.theme,
      interactive = _ref.interactive;
  var button = theme.componentsTokens.icon.button;
  var variants = button.variants,
      defaultVariant = button.defaultVariant,
      focus = button.focus;
  var variant = variants[interactive === true ? defaultVariant : interactive];
  return css(["cursor:pointer;color:", ";transition:color 0.2s ease;&:hover{color:", ";}&:focus{outline:none;}&:focus-visible{outline:none;box-shadow:", " ", ";border-radius:2px;}"], variant.base, variant.hover, focus.params, focus.color);
};

var Icon = styled.svg.attrs(function (_ref2) {
  var interactive = _ref2.interactive;
  return {
    tabIndex: interactive ? "0" : undefined,
    role: interactive ? "button" : undefined
  };
}).withConfig({
  displayName: "Icon",
  componentId: "sc-p5kabi-0"
})(["width:1em;height:1em;", " ", " ", ";", ";", ";", ";", ";"], function (_ref3) {
  var theme = _ref3.theme,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? "m" : _ref3$size;
  return _objectSpread(_objectSpread({
    flexShrink: 0
  }, size !== "inherit" && {
    fontSize: "".concat(theme.componentsTokens.icon.sizes[size], "px")
  }), size === "inherit" && {
    verticalAlign: "-0.125em"
  });
}, function (_ref4) {
  var theme = _ref4.theme,
      interactive = _ref4.interactive;
  return interactive && iconAsButtonStyles({
    theme: theme,
    interactive: interactive
  });
}, fontSize, colors, margins, position, verticalAlign);
export default Icon;